const initState = {
  requestBudgetHours: {},
  budgetRequests: []
}

const budgetRequestsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_REQUEST_BUDGET_FIELD_VALUE':
      return {
        ...state, 
        requestBudgetHours: Object.assign(state.requestBudgetHours, action.value)
      }
    case 'FETCH_BUDGET_REQUESTS':
      return {
        ...state, 
        budgetRequests: action.budgetRequests 
      }
    default: 
      return state;
  }
}

export default budgetRequestsReducer